export function transformDateToAge(date: string) {
  const birthYear = new Date(date).getFullYear()
  const currentYear = new Date().getFullYear()
  const age = currentYear - birthYear
  if (age > 0) {
    return age.toString()
  }
  return ''
}
